<template>
  <div
    v-bind="init"
    class="shadow-lg col-11 col-sm-11 col-md-8 col-lg-8 col-xl-8"
  >
    <div
      v-if="totalSteps === 2"
      class="d-flex w-100 justify-content-evenly my-2"
    >
      <div
        :class="
          currentSteps == 1 ? 'step-indicator step-active' : 'step-indicator'
        "
      ></div>
      <div
        :class="
          currentSteps == 2 ? 'step-indicator step-active' : 'step-indicator'
        "
      ></div>
    </div>
    <div v-else></div>
    <div
      class="upload-container d-flex flex-column flex-sm-column flex-md-column flex-lg-row flex-xl-row col-12 p-2"
      v-if="currentSteps == 1"
    >
      <div
        class="l-container col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 d-flex justify-content-center align-items-start flex-column"
      >
        <h3 class="mx-4 text-default">Track:</h3>
        <div class="input-box mb-2 w-100 d-flex justify-content-center">
          <input
            class="w-100 mx-4 mt-3"
            :class="nameClass"
            @input="onNameChange"
            type="text"
            placeholder="Enter Song name..."
          />
        </div>

        <div class="input-box w-100 d-flex justify-content-center">
          <select
            class="w-100 mx-4 p-1"
            :class="selectedClass"
            v-model="selected"
          >
            <option value="" disabled selected>Select Project...</option>
            <option
              v-for="item in apiEvents.userProjects"
              :key="item.id"
              :value="item.name"
            >
              {{ item.name }}
            </option>
            <input type="text" />
          </select>
        </div>
        <div
          class="input-box mb-2 mt-2 mx-4 d-flex justify-content-between align-items-center"
        >
          <input
            class="w-75 mr-2 pr-new"
            v-model="newName"
            type="text"
            placeholder="New Project..."
          />
          <div class="w-25">
            <button class="btn btn-ap" @click="createProject">Add</button>
          </div>
        </div>

        <div class="decor-box w-100">
          <custom-upload-box
            type="track"
            :acceptFile="categ === 'mastering' ? 'audio' : 'zip'"
          />
        </div>
      </div>

      <div
        class="r-container w-100 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 d-flex flex-column justify-content-end align-items-center"
      >
        <upload-tray type="track" />
        <div class="w-100 mr-4 my-4 d-flex justify-content-end">
          <button
            v-if="totalSteps > 1"
            class="btn btn-ap"
            :disabled="btnCurrentDisabled"
            @click="stepNext"
          >
            Next
          </button>
          <button
            v-else
            class="btn"
            :disabled="btnDisabled"
            :class="loadingBtnClass"
            @click="onUplaod"
          >
            Add Track
          </button>
        </div>
      </div>
    </div>
    <div
      class="upload-container d-flex flex-column flex-sm-column flex-md-column flex-lg-row flex-xl-row col-12 p-2"
      v-else
    >
      <div
        class="l-container col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 d-flex justify-content-center align-items-start flex-column"
      >
        <h3 class="mx-4 text-default">Reference Track:</h3>

        <div class="decor-box w-100">
          <custom-upload-box type="ref" acceptFile="audio" />
        </div>
        <div class="mx-4 w-100">
          <button class="btn btn-ap" @click="stepBack">Back</button>
        </div>
      </div>

      <div
        class="r-container w-100 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 d-flex flex-column justify-content-end align-items-center"
      >
        <upload-ref-tray type="ref" />
        <div
          class="w-100 px-4 pt-2 d-flex justify-content-end align-items-center"
        >
          <div class="progress mx-2" v-if="btnDisabled"></div>

          <button
            class="btn"
            :disabled="btnDisabled"
            :class="loadingBtnClass"
            @click="onUplaod"
          >
            Add Track
          </button>
        </div>
        <div
          class="w-100 px-4 pt-2 d-flex justify-content-end align-items-center"
        ></div>
      </div>
    </div>
    <b-modal
      ref="progress-modal"
      class="progress-modal hide fade in"
      centered
      id="progress-modal"
      no-close-on-backdrop
      hide-header-close
      hide-header
      body-class="progress-modal-body"
      no-fade
      hide-footer
      :title="progressModalTitle"
    >
      <div class="d-block w-100 p-4">
        <h3 class="uploading-text">
          Uploading {{ currentUploadItem }}/{{ totalUploadItems }}
        </h3>
        <progress-bar :options="progressBarOptions" :value="progressValue" />
        <div class="uploading-text d-flex justify-content-end w-100">
          {{ speed }} MB/s
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CustomUploadBox from "@/components/CustomUploadBox.vue";
import UploadTray from "@/components/UploadTray.vue";
import UploadRefTray from "@/components/UploadRefTray.vue";
import axios from "axios";
import { stringHasSpecialCharacters } from "@/utils/string-utils";

export default {
  props: ["categ"],
  mounted() {},
  data() {
    return {
      selected: "",
      allSelected: [],
      mixselected: "",
      name: "",
      newName: "",
      totalSteps: this.categ === "mastering" ? 1 : 2,
      currentSteps: 1,
      selectedclass: "pr-select",
      nameclass: "n-input",
      elements: this.$store.state.trackData.elementList,
      trackUrls: [],
      refUrls: [],
      error: 0,
      uploadError: 0,
      trackStatus: 0,
      disabledbtn: 0,
      // errors
      xhrError: 0,
      nameError: 0,

      signedRequest: "",
      // progress indicator
      totalUploadItems: 2,
      currentUploadItem: 1,
      progressModalTitle: "",
      progressValue: 0,
      timeStamp: 0,
      prevProgress: 0,
      speed: 0,

      progressBarOptions: {
        text: {
          color: "#FFFFFF",
          shadowEnable: true,
          shadowColor: "#000000",
          fontSize: 14,
          fontFamily: "Helvetica",
          dynamicPosition: false,
          hideText: false,
        },
        progress: {
          color: "#2dbd2d",
          backgroundColor: "#333333",
          inverted: false,
        },
        layout: {
          height: 35,
          width: 420,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: "line",
        },
      },
    };
  },
  computed: {
    ...mapState(["apiEvents"], ["trackData"]),

    trackUploadStatus() {
      return this.$store.state.trackData.trackUploadStatus;
    },

    init() {
      this.$swal.fire({
        title:
          "Upload the .wavs of the song you are sending that matches the reference. We want to be able to A/B the reference to the stems and have them match. Many people print everything “wet”. Make sure you take off any limiting that you have on the master buss. Feel free include any screen shots of plug in settings on the master buss.",
        icon: "info",

        confirmButtonText: "Ok",
      });

      return true;
    },
    selectedClass() {
      return this.selectedclass;
    },
    nameClass() {
      return this.nameclass;
    },
    btnDisabled() {
      return this.disabledbtn ? true : false;
    },
    btnCurrentDisabled() {
      return this.$store.state.trackData.currentDataList.length > 0
        ? false
        : true;
    },

    getProgress() {
      return this.$store.state.trackData.uploadProgress;
    },

    loadingBtnClass() {
      return !this.trackStatus ? "a-track" : "a-track-disable";
    },
  },
  components: {
    UploadTray,
    UploadRefTray,
    CustomUploadBox,
  },
  methods: {
    stepNext() {
      if (this.currentSteps < 2) {
        this.currentSteps++;
        this.popupDisplay();
      }
    },
    onNameChange(e) {
      this.name = e.target.value;
      if (stringHasSpecialCharacters(this.name)) {
        this.nameError = 1;
        this.disabledbtn = 1;
        this.nameclass = "inp-danger";
        this.error = 1;
      } else {
        this.nameError = 0;
        this.disabledbtn = 0;
        this.nameclass = "n-input";
      }
    },
    popupDisplay() {
      this.$swal.fire({
        title:
          "Upload your latest bounce of the song you are sending in for mix. We want to hear what you have been listening to but will use this to make sure the files you upload next matches when we prep for mix.",
        icon: "info",

        confirmButtonText: "Ok",
      });
    },
    stepBack() {
      this.currentSteps--;
    },

    createProject() {
      if (this.newName != "") {
        this.$store
          .dispatch("apiEvents/createNewProject", {
            projectName: this.newName,
            userId: localStorage.getItem("userId"),
          })
          .then(() => {
            this.newName = "";
            this.$store.dispatch("apiEvents/fetchProjectsByUserId", {
              id: localStorage.getItem("userId"),
            });
          });
      }
      //
    },
    async onUplaod() {
      if (
        this.name !== "" &&
        this.$store.state.trackData.currentDataList.length > 0
      ) {
        this.disabledbtn = 1;
        this.trackStatus = 0;
        await this.uploadS3Helper(this.name.toString());
      } else {
        if (this.name === "") {
          this.nameclass = "inp-danger";
          this.error = 1;
          this.disabledbtn = 0;
        }
      }
    },

    async uploadS3Helper(trackname) {
      const trackList = this.$store.state.trackData.currentDataList;
      const trackRefList = this.$store.state.trackData.currentRefList;

      this.$refs["progress-modal"].show();

      for (let i = 0; i < trackList.length; i++) {
        const filePathObj = await this.fileKeyPathGenerator(
          trackList[i].file,
          trackname,
          "Track"
        );
        try {
          const res = await this.generateS3Request(
            trackList[i].file,
            filePathObj.key
          );
          await this.uploadOnUrl(res.data.signedRequest, trackList[i].file);

          this.trackUrls.push({
            stemUrl: `https://s3.amazonaws.com/quickmix/${filePathObj.key}`,
            stemGroup: "",
            stemName: trackList[i].file.name,
          });
        } catch (error) {
          this.$refs["progress-modal"].hide();
          await this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });

          this.uploadError = 1;
          throw "exit";
        }
      }
      this.currentUploadItem = 2;
      for (let i = 0; i < trackRefList.length; i++) {
        const filePathObj = await this.fileKeyPathGenerator(
          trackRefList[i].file,
          trackname,
          "References"
        );
        try {
          const res = await this.generateS3Request(
            trackRefList[i].file,
            filePathObj.key
          );
          await this.uploadOnUrl(res.data.signedRequest, trackRefList[i].file);

          this.refUrls.push({
            stemUrl: `https://s3.amazonaws.com/quickmix/${filePathObj.key}`,
            stemGroup: "",
            stemName: trackRefList[i].file.name,
          });
          this.uploadError = 0;
        } catch (error) {
          this.$refs["progress-modal"].hide();
          await this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });

          this.uploadError = 1;
          throw "exit";
        }
      }
      if (!this.uploadError) {
        try {
          await this.createTrackHelper();
        } catch (error) {
          throw "exit";
        }

        await this.useCredits(this.$props.categ);
      }
    },
    async uploadOnUrl(url, file) {
      this.timeStamp = Date.now();
      this.prevProgress = 0;
      this.progressValue = 0;
      let res;
      try {
        res = await axios.put(url, file, {
          headers: {
            "Content-Disposition": "attachment",
            "Content-Type": file.type,
          },
          maxContentLength: Infinity,
          onUploadProgress: (progress) => {
            let percentCompleted = Math.round(
              (progress.loaded * 100) / progress.total
            );
            let time = Date.now() - this.timeStamp;
            let percent = (percentCompleted - this.prevProgress) / 100;
            let chunk = percent * file.size;
            let speed = (chunk / 1024 / 1024 / (time / 1000)).toFixed(2);

            this.timeStamp = Date.now();
            this.prevProgress = percentCompleted;

            this.speed = speed;

            this.progressValue = percentCompleted;
          },
        });
      } catch (error) {
        throw error;
      }
      return res;
    },
    formattedDate() {
      let d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },

    async fileKeyPathGenerator(file, trackName, type) {
      const date = this.formattedDate();
      const fileExt = file.name.split(".").pop();
      const path =
        localStorage.getItem("mxdUserName") +
        `_${type}_` +
        "1" +
        "_" +
        file.name
          .replace("adlib", "adlibs")
          .split("#")
          .join("_")
          .split("&")
          .join("_")
          .split("?")
          .join("_")
          .split(".")
          .slice(0, file.name.split(".").length - 1)
          .toString()
          .split(" ")
          .join("-") +
        "." +
        fileExt;

      const key =
        localStorage.getItem("mxdUserName") +
        `${type === "Track" ? "" : "/References"}/` +
        date +
        "/" +
        trackName.split(" ").join("-") +
        "/" +
        path;
      return {
        key: key,
        path: path,
      };
    },
    async generateS3Request(file, key) {
      let url;
      try {
        url = await this.$store.dispatch("apiEvents/getS3Sig", {
          fileName: file.name,
          fileType: file.type,
          key: key,
        });
      } catch (error) {
        throw error;
      }
      return url;
    },
    async createTrackHelper() {
      const res = await this.$store.dispatch("trackData/createNewTrack", {
        userId: parseInt(localStorage.getItem("userId")),
        trackName: this.name.toString(),
        projectId:
          this.selected != ""
            ? this.$store.state.apiEvents.userProjects.find((item) => {
                return item.name === this.selected;
              }).id
            : 0,
        trackCategory: this.$props.categ,
        trackStyle: "Full",
        trackProject: this.selected,
        username: localStorage.getItem("mxdUserName"),
        trackFiles: this.trackUrls,
        refFiles: this.refUrls,
        elementGroup: this.$props.categ,
      });
      this.responseFunc(res);
    },
    async useCredits(trackType) {
      if (trackType == "track") {
        await this.$store.dispatch("apiEvents/useTrackCredit");
      } else if (trackType == "atmos") {
        await this.$store.dispatch("apiEvents/useAtmosCredit");
      } else if (trackType == "stereo") {
        await this.$store.dispatch("apiEvents/useStereoCredit");
      }
    },
    async responseFunc(res) {
      if (res.data.success) {
        await this.$swal.fire({
          position: "top-end",
          icon: "success",
          title: "Track Uploaded",
          showConfirmButton: false,
          timer: 1500,
        });
        this.$router.push("../dashboard");
      } else {
        await this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    },
  },
};
</script>

<style scoped>
.upload-container {
  background-color: rgb(255, 255, 255);
  border-radius: 7px;
}

.step-indicator {
  height: 10px;
  width: 100%;
  margin: 0 20px 0 20px;
  border-radius: 50px;
  background-color: rgb(42, 42, 42);
}

.step-active {
  background-color: #7dfcd5;
}

.n-input,
.pr-select,
.inp-danger,
.pr-new {
  border: 0px !important;
  font-size: 14px;
  padding: 8px !important;
  background-color: rgb(238, 238, 238);
  border-radius: 5px;
  border: 1px solid rgb(238, 238, 238);
}

.inp-danger {
  border: 1px solid rgb(255, 186, 186) !important;
  background-color: rgb(255, 223, 223);
}

.pr-select option {
  background-color: rgb(255, 255, 255);
  padding: 4px;
}

.btn-ap {
  background-color: #7dfcd5;
  width: 75px;
  height: 34px;
  margin: 0px !important;
  font-size: 14px;
}

.text-default {
  color: #303030;
  font-weight: 500;
}

.a-track {
  background-color: #26ffd4;
}

.a-track-disable {
  pointer-events: none;
  background-color: #cfcfcf;
}

.uploading-text {
  color: #202228;
  padding: 8px 0px 14px 0px;
}
#line-progress {
  border-radius: 4px;
}
</style>
